import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { AdminPageWrapper } from "../AdminPageWrapper";
import {
  Button,
  Separator,
  HStack,
  Input,
  Stack,
  Text,
  Field,
} from "@chakra-ui/react";
import { AdminView } from "../../models/AdminView";
import { AdminCampaignApi } from "../../services/AdminCampaignApi";
import { toast } from "../../../shared/views/CustomToaster";
import { AdminMigrationApi } from "../../services/AdminMigrationApi";

const AdminToolsPageBase: React.FC = () => {
  const [campaignId, setCampaignId] = useState("");

  return (
    <AdminPageWrapper selectedView={AdminView.Tools}>
      <Stack px={6} gap={4} separator={<Separator />}>
        <Text fontSize="2xl">{AdminView.Tools}</Text>

        <Stack>
          <Text>Fix node sorting and location issues</Text>
          <HStack>
            <Field.Root fontSize="sm">
              <Field.Label>
                <Text>Campaign ID</Text>
              </Field.Label>
              <Input
                size="sm"
                value={campaignId}
                onChange={(e) => setCampaignId(e.target.value)}
              />
            </Field.Root>
            <Button
              colorPalette="primary"
              disabled={!campaignId}
              onClick={() =>
                AdminCampaignApi.triggerTroubleshoot(campaignId).then(() =>
                  toast("success", "Triggered!"),
                )
              }
              alignSelf="end"
              size="sm"
            >
              Run
            </Button>
          </HStack>
        </Stack>

        <HStack>
          <Text flexGrow={1}>Re-calculate all remote assessment scores</Text>
          <Button
            size="sm"
            colorPalette="primary"
            onClick={() => {
              toast("info", "Working...");
              AdminMigrationApi.reCalculateRaScores()
                .then(() => toast("success", "Done!"))
                .catch(() => toast("error", "Failed!"));
            }}
          >
            Run
          </Button>
        </HStack>

        <HStack>
          <Text flexGrow={1}>Migrate HlaWays to the new version</Text>
          <Button
            size="sm"
            colorPalette="primary"
            onClick={() => {
              AdminMigrationApi.migrateHlaWays().then(() =>
                toast("success", "Triggered!"),
              );
            }}
          >
            Run
          </Button>
        </HStack>
      </Stack>
    </AdminPageWrapper>
  );
};

export const AdminToolsPage = observer(AdminToolsPageBase);
